import React from "react"
import { injectIntl } from "react-intl"
import IntlProps from "../../../state/helpers/IntlProps"
import { RF_METHOD_TYPES } from "./constants"
import { messages } from "./messages"
import "./styles/rainforest-credit-card.scss"

type OwnProps = {
    method: RF_METHOD_TYPES
    payBtnColor: string
}

const RainforestLoading = (props: OwnProps & IntlProps) => {

    const buttonText = props.method === RF_METHOD_TYPES.PAY_CC
        ? props.intl.formatMessage(messages.pay)
        : props.intl.formatMessage(messages.storeDetails)

    return <>
        <div className="rf-card-network-container">
            <img className="rf-card-network" alt="Rf card network" src="/images/rf_cc/rf_card_network.svg" />
        </div>
        <div className="card-info-container"> 
            <div className="cardholder-name-input">
                <div className="text-line-loading"></div>
            </div>
            <div className="group-card-info">
                <div className="month-input">
                    <div className="text-line-loading"></div>
                </div>
                <div className="cvc-input">
                    <div className="text-line-loading"></div>
                </div>
                <div className="zipcode-input">
                    <div className="text-line-loading"></div>
                </div>
            </div>
        </div>

        <div className="pay-button" style={{backgroundColor: props.payBtnColor}}>
            <img className="pay-bag-icon" alt="pay-bag-icon" src="/images/rf_cc/bag.png" />
            <div className="pay-text">{buttonText}</div>
            {props.method === RF_METHOD_TYPES.PAY_CC && <div className="pay-button-loading"/>}
        </div>
        {props.method === RF_METHOD_TYPES.PAY_CC && 
        <div className="save-card-on-file-container">
            <img className="checkbox-save-card-on-file" alt="checkbox" src="/images/rf_cc/checked_checkbox.png" />
            <div className="loading-save-card-on-file"/>
        </div>
        }
    </>

}

export default injectIntl(RainforestLoading)


// WEBPACK FOOTER //
// ./src/common/credit-card/rf-components/RainforestLoading.tsx